import { createSelector } from 'reselect'
import { COUNTRY_SHORTCODES } from '../constants'

const IS = 'is'

export const applicationSelector = state => state.application
export const applicationCountrySelector = createSelector(
  applicationSelector,
  (application) => {
    const country = application.country
    // Returns an object containing what country was selected in application in form:
    // {
    //   isUS: true,
    //   isCA: false,
    //   ... 
    // }
    const selectedApplicationCountries = Object.values(COUNTRY_SHORTCODES).reduce((obj, value) => {
      const isCountry = country === value // Compares if current country is the application country
      const currentCountry = IS.concat(value) // Creates key for current country
      obj[currentCountry] = isCountry // Adds to obj the key,value pair
      return obj
    }, {})
    return selectedApplicationCountries
  }
)